import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DevotionalState {
  selectedDate: string | null; // ISO date format yyyy-mm-dd
}

const initialState: DevotionalState = {
  selectedDate: null,
};

const devotionalSlice = createSlice({
  name: 'devotional',
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<string | null>) => {
      state.selectedDate = action.payload;
    },
    clearSelectedDate: (state) => {
      state.selectedDate = null;
    },
  },
});

export const { setSelectedDate, clearSelectedDate } = devotionalSlice.actions;
export default devotionalSlice.reducer;
